export default "__VITE_ASSET__CVBaZeqN__"